import { ReducersRegistry } from '@grandvisionhq/state';
import shippingReducer from './state/reducer.js';
import * as index from './operations/index.js';
export { index as Operations };
export { DeliveryIndicator } from './modules/DeliveryIndicator/layout/DeliveryIndicator.js';
export { DeliveryIndicator as DeliveryIndicatorComponent } from './modules/DeliveryIndicator/components/DeliveryIndicator.js';
export { DeliveryIndicatorLoader } from './modules/DeliveryIndicator/components/DeliveryIndicatorLoader.js';
export { DeliveryIndicatorTooltip } from './modules/DeliveryIndicator/components/DeliveryIndicatorTooltip.js';
import 'react';
import '@grandvisionhq/common';
import '@grandvisionhq/elements';
import '@grandvisionhq/iris-ui';
export { useGetDeliveryEstimationMessage } from './hooks/use-get-delivery-estimation-message.js';
export { useGetDispatchDate } from './hooks/use-get-dispatch-date.js';
export { useGetShippingMethods } from './hooks/use-get-shipping-methods.js';
export { useDeliveryIndicator, withDeliveryIndicator } from './contexts/DeliveryIndicator/context.js';
export { DeliveryIndicatorProvider } from './contexts/DeliveryIndicator/provider.js';
export { setPreferredShippingMethod } from './state/actions.js';
export { getPreferredShippingMethod } from './state/selectors.js';
export { defaultDeliveryResolver } from './utils/default-delivery-resolver.js';

ReducersRegistry.register('shipping', shippingReducer);
//# sourceMappingURL=index.js.map
